import { useSnackbar } from 'notistack';
import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Reducers, Status } from '../Interfaces/Interfaces';
import { getAgentAccount, getBanks } from '../redux/actions/configActions';
import { createCashoutAccount } from '../redux/actions/CoordinatorActions';
import { resolveAccount } from '../redux/actions/FundsTransferActions';
import { createAccount } from '../redux/actions/userActions';
import PrimaryTheme from '../Themes/Primary';
import Input from './Input'
import { Icon } from '@material-ui/core';

export default function SetUpCashoutAccount(props: BannerProps) {
  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);
  const cashout = useSelector((state: Reducers) => state.cashout);
  const userType = useSelector((state: Reducers) => state.userType);
  const banks = useSelector((state: Reducers) => state.banks);
  const generic = useSelector((state: Reducers) => state.generic);
  const agent = useSelector((state: Reducers) => state.agentDetails);
  const loading = useSelector((state: Reducers) => state.loading);
  // const coordinatorType = useSelector((state: Reducers) => state.coordinatorType);

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [bank, setBank] = React.useState("");
  const [bankArray, setBankArray]: any = React.useState([]);
  const [agentName, setAgentName] = React.useState('');
  const [agentPhoneNumber, setAgentPhoneNumber] = React.useState('');
  const [accountNumber, setAccountNumber] = React.useState('');
  const [accountName, setAccountName] = React.useState('');
  const [submitted, setSubmitted]: any = React.useState(false);
  const [agentId, setAgentId] = React.useState('');
  const [pin, setPin] = React.useState('');
  const [visible, setVisibility] = React.useState(false);


  const handleSubmit = () => {

    let data = {
      pin,
      accountNumber,
      bankId: bankArray[0],
      accountName: generic.accountName,
      bankName: bankArray[1],
      agentId,
    }

    dispatch({
      type: 'LOADING',
      payload: true
    });

    if (userType === "5") {
      dispatch(createAccount(data))
    } else {
      dispatch(createCashoutAccount(data));
    }

  }


  const reset = () => {
    setAccountNumber('');
    setAccountName('');
    setPin('');
    setAgentPhoneNumber('');
    setAgentName('');
  }

  React.useEffect(() => {
    reset();
  }, [])

  // check for institution changes and reset accountNumber
  React.useEffect(() => {
    setAccountNumber('');
    setAccountName('');
    setPin('')
    banks.forEach(e => {
      let myBankArr: any = []
      myBankArr = [`${e.id}`, e.name]
      setBankArray(myBankArr);
    })
    setAgentId(user.id)

  }, [user, banks, bank])


  React.useEffect(() => {
    setAccountName('');
    dispatch({
      type: 'GENERIC',
      payload: {}
    })

  }, [accountNumber, dispatch])

  React.useEffect(() => {    
    if (Object.entries(generic).length !== 0) {
      if(accountNumber!='') {
        setAccountName(generic.accountName);
      }else {
        setAccountName('')
        setPin('')
      }
    }

    if (Object.entries(agent).length !== 0) {
      setAgentName(agent.name);
      setAgentId(agent.id)
    }
  }, [generic, agent])

  React.useEffect(() => {
    if (accountNumber.length === 10) {
      let data = {
        bankId: bankArray[0],
        accountNumber
      }

      dispatch({
        type: 'LOADING',
        payload: true
      });

      dispatch(resolveAccount(data));
    }

  }, [dispatch, accountNumber])



  React.useEffect(() => {
    setPin('')
    dispatch(getBanks());
    dispatch({
      type: 'LOADING',
      payload: true
    })

    return () => {
      dispatch({
        type: 'GET_BANKS',
        payload: []
      })
    }
  }, [dispatch])

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        dispatch({
          type: 'LOADING',
          payload: false
        })

        dispatch({
          type: 'ALERT',
          payload: {}
        });

        setSubmitted(false);

      } else {
        enqueueSnackbar(alert.message, { variant: "success" });
        dispatch({
          type: "STATUS_ALERT",
          payload: true
        });

        dispatch({
          type: 'ALERT',
          payload: {}
        });
      }
    }
  }, [dispatch, enqueueSnackbar, alert, history]);

  return (
    <div>
      <form autoComplete="off">


        <div className="col-md-12 mb-3 p-0">
          <label htmlFor="accountNumber" style={{
            fontFamily: PrimaryTheme.fonts?.RubikMedium,
            fontSize: PrimaryTheme.fontSizes?.small,
          }}>Bankly Account Number</label>

          <Input
            type={"number"}
            inputMode="text"
            isInput
            disabled={loading}
            id="accountNumber"
            value={accountNumber}
            maxLength={10}
            onChange={(e) => setAccountNumber(e.target.value)}
            placeholder='Account Number'
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              backgroundColor: PrimaryTheme.background,
              color: PrimaryTheme.dark,
              marginBottom: '-10px'
            }} />
          <div className="d-flex m-0 align-items-center">
            <span className="pr-2 p-0 pt-2">
              <Icon style={{
                color: props.iconColor
              }}>information</Icon>
            </span>
            <span
              style={{
                marginBottom: '-10px',
                fontSize: '14px'
              }}
            >
              You can only withdraw to a Bankly account.
            </span>
          </div>
        </div>
        
        
        {accountName!==''&&
          <div className='mb-3'>
            <span style={{
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '16px',
              paddingRight: '16px',
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '14px',
              lineHeight: '26px',
              color: '#000000',
              background: '#EEF4FF',
              borderRadius: 12
            }}
            >
              {accountName}
            </span>

          </div>
        }


        <div className="col-md-12 p-0">
          <label
            htmlFor="pin"
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikMedium,
              fontSize: PrimaryTheme.fontSizes?.small,
              fontWeight: 500
            }}
          >
            Transaction PIN
          </label>

          <Input
            type={"password"}
            // isPassword
            isInput
            id="pin"
            placeholder='Enter Transaction PIN'
            maxLength="4"
            size="4"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              backgroundColor: PrimaryTheme.background,
              color: PrimaryTheme.dark,
              marginBottom: '-10px'
            }}
          />
          <div className="d-flex m-0 align-items-center">
            <span className="pr-2 p-0 pt-2">
              <Icon style={{
                color: props.iconColor
              }}>information</Icon>
            </span>
            <span
              style={{
                marginBottom: '-10px',
                fontSize: '14px'
              }}
            >
              PIN used to authenticate transactions
            </span>
          </div>
        </div>



        <div className="col-md-12 px-0 ml-auto mr-auto mb-0 text-center">

          <Input
            type="button"
            isInput
            id="submit"
            value={(submitted || loading) ? "Please wait..." : "Continue"}
            disabled={submitted ||
              pin.length === 0 ||
              accountNumber === "" ||
              pin === "" ||
              loading
            }
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikBold,
              backgroundColor: PrimaryTheme.primary,
              color: PrimaryTheme.white,
              padding: '1.1rem',
              borderRadius: 100,
              marginTop: '48px'
            }}
            onClick={handleSubmit}
          />

        </div>

      </form>

    </div>
  )
}

interface BannerProps {
  borderColor?: string;
  backgroundColor?: string;
  iconColor?: string;
  text?: string;
  className?: "bq-warning" | "bq-info" | "bq-danger" | "bq-success" | undefined;
}
